<form
	(ngSubmit)="onSubmit(changeFileForm)"
	#changeFileForm="ngForm"
	class="flex flex-col justify-between h-full pt-8"
>
	<div class="flex-grow overflow-y-auto px-6 pb-6">
		<ui-button-segmented
			label="Matter Status"
			[options]="matterStatusOptions"
			[selectedId]="status"
			[fullWidth]="true"
			variant="text-only"
			(selectedIdChange)="setStatus($event)"
		></ui-button-segmented>
		<app-input
			class="mt-3"
			label="Matter Name"
			[(ngModel)]="fileName"
			name="fileName"
			[submitted]="changeFileForm.submitted"
			[required]="true"
		></app-input>
		<app-input
			class="mt-3"
			label="Matter #"
			[(ngModel)]="fileNumber"
			name="fileNumber"
			[appUniqueMatterNumber]="false"
			[submitted]="changeFileForm.submitted"
			[required]="true"
		></app-input>
		<app-input
			class="mt-3"
			label="Account #"
			[(ngModel)]="fileAccountingNumber"
			name="fileAccountingNumber"
			[submitted]="changeFileForm.submitted"
		></app-input>
		<div [@openClose] class="mt-3">
			<app-select
				label="Office Name"
				[required]="true"
				[(ngModel)]="office"
				name="office"
				[submitted]="changeFileForm.submitted"
			>
				@for (_office of offices; track _office.id) {
					<option [value]="_office.id">
						{{ _office.officeNickName || _office.officeName }}
					</option>
				}
			</app-select>
			<div
				*ngIf="showOfficialOfficeName"
				class="text-sm text-gray-500 font-normal mt-1"
			>
				Office Name (Official): {{ officialOfficeName }}
			</div>
		</div>
		<div *ngIf="fileType === fileTypes.REFINANCE" [@openClose] class="mt-3">
			<app-select
				label="Acting for"
				[required]="true"
				[(ngModel)]="actingFor"
				name="actingFor"
				[submitted]="changeFileForm.submitted"
			>
				<option [value]="actingForTypes.MORTGAGEE">Mortgagee</option>
				<option [value]="actingForTypes.MORTGAGOR">Mortgagor</option>
				<option [value]="actingForTypes.BOTH_PRIMARY_MORTGAGEE">
					Both (primary client is Mortgagee)
				</option>
				<option [value]="actingForTypes.BOTH_PRIMARY_MORTGAGOR">
					Both (primary client is Mortgagor)
				</option>
			</app-select>
		</div>
		<div [@openClose] class="mt-3">
			<app-select
				label="Lawyer On Matter"
				[required]="true"
				[(ngModel)]="lawyerOnMatter"
				name="lawyerOnMatter"
				[submitted]="changeFileForm.submitted"
			>
				@for (lawyer of lawyers; track lawyer.id) {
					<option [value]="lawyer.id">
						{{ getFullNameFromBusinessUser(lawyer) }}
					</option>
				}
			</app-select>
		</div>
		<div [@openClose] class="mt-3">
			<app-select
				label="Clerk On Matter"
				[(ngModel)]="clerkOnMatter"
				name="clerkOnMatter"
				[submitted]="changeFileForm.submitted"
			>
				<option>None</option>
				@for (clerk of clerks; track clerk.id) {
					<option [value]="clerk.id">
						{{ getFullNameFromBusinessUser(clerk) }}
					</option>
				}
			</app-select>
		</div>
	</div>

	<div class="p-6 border-t border-gray-200">
		<ui-button preset="HIGH_EMPHASIS" label="Save" type="submit"></ui-button>
	</div>
</form>
